/**
 * Does this document already have older versions? Such a document offers
 * "Versioning" (reorder, separate, add) where a single-version one offers
 * "Add new version". Like the list and timeline history affordances it
 * goes by the head's number, but unlike them (`(version ?? 1) > 1`) it also
 * counts a head with no number: that is a legacy lineage, the kind most in
 * need of the dialog.
 */
export function hasVersionHistory(doc: {
  version?: number | null;
  version_group?: string | null;
}): boolean {
  return !!doc.version_group && (doc.version == null || doc.version > 1);
}
